import EventChannel from '../../events/EventChannel';
import { CUSTOM_EVENTS, TOPICS } from '../../events/constants';
import FaqApp from './faq/FaqApp';
import ErrorBoundary from '../../components/ErrorBoundary';
import onDomContentLoaded from '../../utilities/onDomContentLoaded';
import '../../../scss/pages/faq/main.scss';
import { Store } from '../../types/store';
import { ThemeProvider } from '@mui/material/styles';
import theme from '../../theme';
import CssBaseline from '@mui/material/CssBaseline';

import { createRoot } from 'react-dom/client';

function startup() {
    const faq = document.getElementById('page--faq');

    if (faq) {
        const root = createRoot(faq);
        const eventChannel = new EventChannel();
        const myStoreModuleUpdatesEvent = new CustomEvent(CUSTOM_EVENTS.MY_STORE_MODULE_UPDATES, {
            detail: {
                done: (store: Store) => eventChannel.publish(TOPICS.MY_STORE_MODULE_UPDATES, store),
            },
        });

        const faqAppProps = {
            eventChannel: eventChannel,
        };

        root.render(
            <ErrorBoundary>
                <ThemeProvider theme={theme}>
                    <CssBaseline />
                    <FaqApp {...faqAppProps} />
                </ThemeProvider>
            </ErrorBoundary>,
        );

        document.documentElement.dispatchEvent(myStoreModuleUpdatesEvent);
    }
}

onDomContentLoaded(() => {
    startup();
});
